export default [
  {
    title: 'Forms',
    icon: { icon: 'mdi-checkbox-multiple-outline' },
    children: [
      {
        title: 'Form Elements',
        icon: { icon: 'mdi-content-copy' },
        children: [
          {
            title: 'Checkbox',
            to: 'forms-checkbox',
          },
          {
            title: 'Combobox',
            to: 'forms-combobox',
          },
          {
            title: 'Date Time Picker',
            to: 'forms-date-time-picker',
          },
          {
            title: 'File Input',
            to: 'forms-file-input',
          },
          {
            title: 'Radio',
            to: 'forms-radio',
          },
          {
            title: 'Range Slider',
            to: 'forms-range-slider',
          },
          {
            title: 'Rating',
            to: 'forms-rating',
          },
          {
            title: 'Select',
            to: 'forms-select',
          },
          { title: 'Slider', to: 'forms-slider' },
          {
            title: 'Switch',
            to: 'forms-switch',
          },
          {
            title: 'Textarea',
            to: 'forms-textarea',
          },
          {
            title: 'Textfield',
            to: 'forms-textfield',
          },
        ],
      },
      {
        title: 'Form Layouts',
        icon: { icon: 'mdi-checkbox-marked-circle-outline' },
        to: 'forms-form-layouts',
      },
      {
        title: 'Form Validation',
        icon: { icon: 'mdi-checkbox-marked-circle-outline' },
        to: 'forms-form-validation',
      },
    ],
  },
]
